// extracted by mini-css-extract-plugin
export default {"root":"Header_root__2bNVY","container":"Header_container__Pv0TG","component":"Header_component__FIu73","component__text":"Header_component__text__RnRR2"};